import {
	ApiClientManager,
	CreateContextInputDto,
	CreateContextOutputDtoSingleOutputMessage,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput, UseFetchInputOnSuccess } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useFetch, useLoader } from '@hooks';

export const useFetchCreateContext = (): UseFetchHookOutput<
	CreateContextInputDto,
	CreateContextOutputDtoSingleOutputMessage
> => {
	const globalLoader = useLoader('global');
	return useFetch<CreateContextInputDto, CreateContextOutputDtoSingleOutputMessage>({
		fetchFn: (createContextData: CreateContextInputDto) => {
			globalLoader.show();
			return ApiClientManager.call.createContext({ data: { ...createContextData } });
		},
		onSuccess: (res: UseFetchInputOnSuccess<CreateContextInputDto, CreateContextOutputDtoSingleOutputMessage>) => {
			if (res.data) {
				globalLoader.hide();
			}
		},
	});
};
